/**
 * Apply a reviewed draft locally. Does not call Gemini.
 * Writes operator rules into the always-included head block.
 */

import { writeRulesIntoKb } from './kbPromptBudget';

export { applyDraftToKb, formatDraftAdditions } from './kbPromptBudget';

export function appendDraftBlock(kbContent, additionText) {
  return writeRulesIntoKb(kbContent, additionText);
}

export function buildAppendDiff(additionText) {
  return (additionText || '')
    .split('\n')
    .map((line) => `+ ${line}`);
}
